<script>
import ObjectGridAdvanced from "@/components/ObjectGridAdvanced.vue";
import FormField from "@/components/feedback/FormField.vue";
import ApiService from "@/api/ApiService";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import NotificationSnackbar from "@/components/NotificationSnackbar.vue";
import FeedbackHeader from "@/components/feedback/FeedbackHeader.vue";
import PromptForm from "@/components/PromptForm";
import { mapActions } from "vuex";
import axios from "axios";

const URL_PUBLIC = "feedback";
const URL_API = "api/feedback";

export default {
  components: {
    FeedbackHeader,
    NotificationSnackbar,
    ErrorMessageWrapper,
    FormField,
    ObjectGridAdvanced,
  },
  data() {
    return {
      isVisibleModal: false,
      isArchiveFeedback: false,
      feedbackList: [],
      selectedType: null,
      fields: [
        {
          key: "label",
          label: "Заголовок",
          type: "richtext",
          required: true,
          cols: 12,
          singleLine: true,
        },
        {
          key: "review",
          label: "Отзыв",
          type: "richtext",
          required: true,
          cols: 12,
        },
        {
          key: "img",
          label: "Изображение",
          type: "file",
          accept: "image/*",
          cols: 12,
        },
        {
          key: "audio",
          label: "Аудио",
          type: "file",
          accept: "audio/*",
          cols: 12,
        },
        {
          key: "video",
          label: "Видео (ID Kinescope)",
          type: "textInput",
          typeInput: "text",
          cols: 12,
        },
        {
          key: "type",
          label: "Тип отзыва",
          type: "select",
          variants: [
            { value: "upmind-landing", label: "Upmind Landing" },
            { value: "upmind-b2c", label: "Upmind B2C" },
            { value: "neurobica-b2c", label: "Neurobica B2C" },
          ],
          required: true,
          cols: 12,
        },
        {
          key: "page",
          label: "Страница",
          type: "select",
          variants: [
            { value: "home", label: "Главная" },
            { value: "about-method", label: "О методе" },
            { value: "logopedia", label: "Логопедия" },
            { value: "ras", label: "РАС" },
            { value: "sdvg", label: "СДВГ" },
            { value: "dtsp", label: "ДЦП" },
            { value: "down", label: "Синдром Дауна" },
            { value: "zpr", label: "ЗПР" },
            { value: "motorika", label: "Моторика" },
            { value: "tiki", label: "Тики" },
            { value: "specialists", label: "Специалистам" },
          ],
          cols: 12,
        },
      ],
      selectedFeedback: {},
      isSnackbarVisible: false,
    };
  },
  computed: {
    filteredFields() {
      return this.fields.filter((field) => {
        if (field.key === "page") {
          return this.selectedFeedback.type === "upmind-landing";
        }
        return true;
      });
    },
    tableFields() {
      return this.fields
        .filter((item) => !["img", "audio", "video"].includes(item.key))
        .map((field) => {
          return {
            text: field.label,
            value: field.key,
          };
        });
    },
    gridActions() {
      return {
        edit: !this.isArchiveFeedback,
        delete: !this.isArchiveFeedback,
        restore: this.isArchiveFeedback,
      };
    },
    filteredFeedbackList() {
      let filtered = this.feedbackList;
      if (this.selectedType) {
        filtered = filtered.filter((item) => item.type === this.selectedType);
      }
      return filtered;
    },
  },
  watch: {
    isArchiveFeedback() {
      this.getFeedbackList();
    },
    selectedType() {
      this.getFeedbackList();
    },
  },
  async mounted() {
    await this.getFeedbackList();
  },
  methods: {
    ...mapActions("modals", ["showModalForm"]),
    async getFeedbackList() {
      const params = {};
      if (this.isArchiveFeedback) {
        params.archive = "1";
      }
      if (this.selectedType) {
        params.type = this.selectedType;
      }
      const { data } = await ApiService.get(URL_PUBLIC, params);
      this.feedbackList = data;
    },
    async getFeedbackById(id) {
      const { data } = await ApiService.get(`${URL_PUBLIC}/${id}`);
      this.selectedFeedback = data;
    },
    async openModalFeedback(feedback) {
      this.selectedFeedback = {};
      await this.getFeedbackById(feedback.id);
      this.isVisibleModal = true;
    },
    async saveFeedback() {
      if (!this.selectedFeedback.id) {
        await this.createFeedback();
        return;
      }

      try {
        const formData = new FormData();

        Object.keys(this.selectedFeedback).forEach((key) => {
          if (key === "img" || key === "audio") {
            if (this.selectedFeedback[key] instanceof File) {
              formData.append(key, this.selectedFeedback[key]);
            }
          } else if (key === "deleteImg" || key === "deleteAudio") {
            if (this.selectedFeedback[key] === true) {
              formData.append(key, "true");
            }
          } else if (
            key !== "id" &&
            this.selectedFeedback[key] !== undefined &&
            this.selectedFeedback[key] !== null
          ) {
            formData.append(key, this.selectedFeedback[key]);
          }
        });

        const BASE_URL =
          process.env.VUE_APP_SERVER_URI || "http://localhost:3000";

        const response = await axios.put(
          `${BASE_URL}/${URL_API}/${this.selectedFeedback.id}`,
          formData,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data && response.data.error) {
          await this.$refs.error_wrapper.showErrorMessage(
            "Ошибка",
            response.data.error
          );
        } else {
          this.isSnackbarVisible = true;
          this.isVisibleModal = false;
          await this.getFeedbackList();
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.error ||
          error.message ||
          "Ошибка при сохранении";
        await this.$refs.error_wrapper.showErrorMessage("Ошибка", errorMessage);
      }
    },
    async deleteFeedbackById(feedback) {
      await this.showModalForm({
        component: PromptForm,
        title: "Вы уверены что хотите удалить отзыв?",
        desc: "Подтвердите действие",
        value: feedback,
      });

      const { data } = await ApiService.delete(`${URL_API}/${feedback.id}`);
      if (data.error) {
        await this.$refs.error_wrapper.showErrorMessage("Ошибка", data.error);
      } else {
        this.isSnackbarVisible = true;
        await this.getFeedbackList();
      }
    },
    async restoreFeedback(feedback) {
      const { data } = await ApiService.put(`${URL_API}/${feedback.id}`, {
        active: true,
      });
      if (data.error) {
        await this.$refs.error_wrapper.showErrorMessage("Ошибка", data.error);
      } else {
        this.isSnackbarVisible = true;
        await this.getFeedbackList();
      }
    },
    addNewFeedback() {
      this.selectedFeedback = {
        label: "",
        review: "",
        type: "upmind-landing",
        page: "",
        img: null,
        audio: null,
        video: "",
        active: true,
      };
      this.isVisibleModal = true;
    },
    async createFeedback() {
      try {
        const formData = new FormData();

        Object.keys(this.selectedFeedback).forEach((key) => {
          if (key === "img" || key === "audio") {
            if (this.selectedFeedback[key] instanceof File) {
              formData.append(key, this.selectedFeedback[key]);
            }
          } else if (
            key !== "id" &&
            this.selectedFeedback[key] !== undefined &&
            this.selectedFeedback[key] !== null &&
            this.selectedFeedback[key] !== ""
          ) {
            formData.append(key, this.selectedFeedback[key]);
          }
        });

        const BASE_URL =
          process.env.VUE_APP_SERVER_URI || "http://localhost:3000";

        const response = await axios.post(
          `${BASE_URL}/${URL_PUBLIC}/`,
          formData,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data && response.data.error) {
          await this.$refs.error_wrapper.showErrorMessage(
            "Ошибка",
            response.data.error
          );
        } else {
          this.isSnackbarVisible = true;
          this.isVisibleModal = false;
          await this.getFeedbackList();
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.error || error.message || "Ошибка при создании";
        await this.$refs.error_wrapper.showErrorMessage("Ошибка", errorMessage);
      }
    },
  },
};
</script>

<template>
  <div>
    <notification-snackbar :value.sync="isSnackbarVisible" />
    <div class="d-flex justify-space-between align-center mb-4">
      <feedback-header module-name="" :value.sync="isArchiveFeedback" />
      <v-btn
        v-if="!isArchiveFeedback"
        color="#d86568"
        large
        rounded
        class="pa-5 px-sm-10 white--text"
        @click="addNewFeedback"
      >
        <v-icon left>mdi-plus</v-icon>
        Добавить
      </v-btn>
    </div>

    <v-chip-group
      v-model="selectedType"
      active-class="primary accent-4 white--text"
      column
      class="mb-4"
    >
      <v-chip color="white" :value="null"> Все типы </v-chip>
      <v-chip color="white" value="upmind-landing"> Upmind Landing </v-chip>
      <v-chip color="white" value="upmind-b2c"> Upmind B2C </v-chip>
      <v-chip color="white" value="neurobica-b2c"> Neurobica B2C </v-chip>
    </v-chip-group>

    <object-grid-advanced
      :value="filteredFeedbackList"
      :field-defs="tableFields"
      :show-actions="gridActions"
      title="Отзывы"
      @doEditItem="openModalFeedback"
      @doDeleteItem="deleteFeedbackById"
      @doRestoreItem="restoreFeedback"
    />
    <v-dialog v-model="isVisibleModal" max-width="800">
      <form-field
        :fields="filteredFields"
        :value.sync="selectedFeedback"
        @submit="saveFeedback"
      />
    </v-dialog>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<style scoped lang="scss"></style>
